import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const notify = (msg) => {
  toast.error(msg, {
    position: "bottom-center",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
  });
  toast.clearWaitingQueue();
};
export const AuthErrorMessages = (errorCode) => {
  switch (errorCode) {
    case "auth/user-not-found":
      notify("User not found");
      break;

    case "auth/wrong-password":
      notify("Incorrect password");
      break;

    case "school/school-does-not-exist":
      notify("School does not exist, please try another school");
      break;
    case "student/registration-number-exists":
      notify("Registration Number Already exists.Enter A different");
      break;

    case "teacher/employee-id-exists":
      notify("Employee with this ID already exist. Please enter different ID");
      break;
    case "auth/email-already-in-use":
      notify("Email already registered");
      break;

    default:
      notify("Unknown Error");
      break;
  }
};

const WarnToast = (msg) => {
  toast.warn(msg, {
    position: "bottom-center",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
  });
};

export const ToastWarnMessages = (warnCode) => {
  switch (warnCode) {
    case "invalid/registration-number":
      WarnToast("Enter a valid registration number.");
      break;
    case "school/first":
      WarnToast("Enter a valid school name first");
      break;

    default:
      WarnToast("Unknown warning");
      break;
  }
};
export const info = (msg) => {
  toast.info(msg, {
    position: "bottom-center",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
  toast.clearWaitingQueue();
};

export const ToastInfoMessages = (infoCode) => {
  switch (infoCode) {
    case "identity/code":
      info("Message");
      break;
    case "school/first":
      info("Enter a valid school name first");
      break;

    default:
      info("Unknown Error");
      break;
  }
};

const success = (msg) => {
  toast.success(msg, {
    position: "bottom-center",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
  toast.clearWaitingQueue();
};
export const ToastSuccessMessages = (infoCode) => {
  switch (infoCode) {
    case "sports/add-successful":
      success("Sport added successfully");
      break;
    case "sports/update-successful":
      success("Sport updated successfully");
      break;
    case "sports/delete-successful":
      success("Sport deleted successfully");
      break;

    case "hostel/add-successful":
      success("Room added successfully");
      break;
    case "hostel/update-successful":
      success("Room updated successfully");
      break;
    case "hostel/delete-successful":
      success("Room deleted successfully");
      break;

    case "transport/add-successful":
      success("Transport added successfully");
      break;
    case "transport/update-successful":
      success("Transport updated successfully");
      break;
    case "transport/delete-successful":
      success("Transport deleted successfully");
      break;

    case "holiday/add-successful":
      success("Holiday added successfully");
      break;
    case "holiday/update-successful":
      success("Holiday updated successfully");
      break;
    case "holiday/delete-successful":
      success("Holiday deleted successfully");
      break;

    case "book/add-successful":
      success("Book added successfully");
      break;
    case "book/update-successful":
      success("Book updated successfully");
      break;
    case "book/delete-successful":
      success("Book deleted successfully");
      break;

    case "request/delete-successful":
      success("User Request Deleted Successfully");
      break;

    default:
      success("Unknown Error");
      break;
  }
};
